import { makeStyles } from '@material-ui/core';
import { colorSet } from '@components/Provider';

export const useCardStyle = makeStyles((theme) => ({
  root: {
    padding: 40,
    [theme.breakpoints.down('xs')]: {
      padding: 20
    }
  },
  inputRoot: {
    '& .MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${colorSet.gray400}`
    },
    '& .MuiInputBase-fullWidth': {
      height: 42
    },
    '& input, textarea': {
      fontSize: 14,
      wordBreak: 'keep-all'
    },
    '& .remove-red-eye-icon': {
      cursor: 'pointer',
      '& .MuiSvgIcon-root': {
        color: colorSet.gray700
      }
    }
  }
}));
